<!-- Generated template for the MysportSportartListItemComponent component -->
<div text-center padding [class.active]="selected" class="sportart">
  <mysport-icon [cid]="category.id" gray huge> </mysport-icon>
  <p no-margin margin-top>{{ category.uniqueName | translate }}</p>
</div>
